import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Brand } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { niceText } from "@/components/Nice";

export const SimplePage = ({ testId, back = "/", backLabel = "Back to NICE", children, wide }) => (
  <div className="pp-app mode-kid" data-testid={testId}>
    <header className="pp-header">
      <Brand />
      <Link to={back} className="pp-ghost" data-testid="simple-back-link"><ArrowLeft className="h-4 w-4" /> {niceText(backLabel)}</Link>
    </header>
    <main className={`pp-main ${wide ? "pp-wide" : ""}`}>{children}</main>
    <Footer />
  </div>
);
